import Tippy from '@tippyjs/react/headless';

export default Tippy;
